import React from "react";
import IQueuedReport from "../../../../shared/contracts/IQueuedReport";
import useReportApi from "../useReportApi";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { ReportStatus } from "../../../../shared/enums/ReportStatus";
import useAppStoreContext from "../../../../shared/context/app-store/app-store.context";

interface CloudDownloadRendererProps {
  data: IQueuedReport;
}

const CloudDownloadRenderer: React.FC<CloudDownloadRendererProps> = ({
  data,
}) => {
  const { downloadReport } = useReportApi();
  const { tenantCode } = useAppStoreContext();

  const handleDownload = () => {
    downloadReport(data.reportSubscriptionId, {
      doBefore: () => {},
      onFulfilled: () => {},
      onException: (exception: { message: any }) =>
        console.error(`Download failed: ${exception.message}`),
    });
  };

  if (
    [ReportStatus.Completed.toUpperCase()].includes(
      data.statusDescription as ReportStatus
    )
  ) {
    return (
      <div style={{ textAlign: "center", cursor: "pointer" }}>
        <CloudDownloadIcon
          onClick={handleDownload}
          style={{ fontSize: 24 }}
          titleAccess="Download"
        />
      </div>
    );
  }
  return null;
};

export default CloudDownloadRenderer;
